import { Box, Flex, Text } from '@chakra-ui/react';

const MarketplaceEmptyActive = () => (
  <Box
    bg="offerTopCardTint"
    borderWidth="1px"
    borderColor="offerTopBadgeBG"
    borderRadius="12px"
    px={{ base: '18px', md: '22px' }}
    py={{ base: '16px', md: '18px' }}
  >
    <Flex align="baseline" gap="8px">
      <Box w="7px" h="7px" borderRadius="full" bg="leaseEndGreen" flexShrink={0} mt="6px" />
      <Box>
        <Text fontFamily="heading" fontSize="15px" fontWeight="700" color="leaseEndBlue">
          Your listing is still live.
        </Text>
        <Text fontSize="13px" color="grayLight" mt="2px">
          Active offers will show here.
        </Text>
      </Box>
    </Flex>
  </Box>
);

export default MarketplaceEmptyActive;
